// RatingContext.js
import React, { createContext, useState, useEffect } from "react";

export const RatingContext = createContext();

const RATING_STORAGE_KEY = "user-rating";

export const RatingProvider = ({ children }) => {
  const [rating, setRating] = useState(0);

  useEffect(() => {
    const stored = localStorage.getItem(RATING_STORAGE_KEY);
    if (stored) setRating(Number(stored));
  }, []);

  const updateRating = (value) => {
    setRating(value);
    localStorage.setItem(RATING_STORAGE_KEY, value);
  };

  return (
    <RatingContext.Provider value={{ rating, updateRating }}>
      {children}
    </RatingContext.Provider>
  );
};
